import { render, staticRenderFns } from "./PhotovoltaicCard.vue?vue&type=template&id=2f22e05e"
import script from "./PhotovoltaicCard.vue?vue&type=script&lang=js"
export * from "./PhotovoltaicCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports